import {createBottomTabNavigator} from '@react-navigation/bottom-tabs';
import React from 'react';
import {mainTab} from 'screens';
import FooterApp from './FooterApp';
import {translateXOptionsScreen} from './optionsNavigate';

const Tab = createBottomTabNavigator();

function TabContainer() {
  return (
    <Tab.Navigator
      // initialRouteName={'TransactionScreen'}
      screenOptions={translateXOptionsScreen}
      tabBar={props => <FooterApp {...props} />}>
      {mainTab.map((item, _) => {
        return (
          <Tab.Screen
            key={item.name}
            name={item.name}
            component={item.component}
          />
        );
      })}
    </Tab.Navigator>
  );
}

export default React.memo(TabContainer);
